// extracted by mini-css-extract-plugin
module.exports = {"head":"Comments_head__1EPQn","form":"Comments_form__2lwVy","title":"Comments_title__t3Jqd"};